import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Image, Alert, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { API_URL, API_URL_UPLOADS } from './config';

const SignUp = () => {
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    sex: '',
    dob: '',
    phone: '',
    email: '',
    username: '',
    password: '',
    confirmPassword: ''
  });
  const [profilePreview, setProfilePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ageError, setAgeError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleProfilePicChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validation logic
    if (formData.password !== formData.confirmPassword) {
      setPasswordError("Passwords do not match.");
      setLoading(false);
      return;
    }

    // Simulate a successful signup
    Swal.fire({
      title: 'Success!',
      text: 'Your account has been created.',
      icon: 'success',
      confirmButtonText: 'OK',
    }).then(() => {
      navigate('/login'); // Redirect to login page
    });

    setLoading(false);
  };

  return (
    <div style={{ 
      backgroundColor: '#fff', 
      minHeight: '100vh', 
      paddingTop: '2rem', 
      paddingBottom: '2rem',
    }}>
      <Container className="p-5" style={{
        backgroundColor: '#fff',
        borderRadius: '20px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        maxWidth: '700px', 
      }}>
        <div className="text-center mb-4">
          <h2 style={{ 
            color: '#000', 
            fontWeight: '700',
            fontSize: '2rem',
            marginBottom: '1rem'
          }}>Create Your Account</h2>
          <p style={{ color: '#666', fontSize: '1rem' }}>Join our community and start your journey</p>
        </div>

        <Row className="justify-content-center mb-4">
          <Col md={4} className="text-center">
            <div className="position-relative d-inline-block">
              {profilePreview ? (
                <Image 
                  src={profilePreview} 
                  roundedCircle 
                  width={180} 
                  height={180} 
                  style={{ 
                    objectFit: 'cover', 
                    border: '5px solid #fff',
                    boxShadow: '0 5px 20px rgba(0,0,0,0.15)'
                  }} 
                />
              ) : (
                <div style={{
                  width: '180px',
                  height: '180px',
                  borderRadius: '50%',
                  background: 'linear-gradient(45deg, #f8f9fa, #e9ecef)',
                  border: '5px solid #fff',
                  boxShadow: '0 5px 20px rgba(0,0,0,0.15)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  color: '#adb5bd'
                }}>
                  <i className="far fa-user"></i>
                </div>
              )}
              <label 
                className="position-absolute"
                style={{
                  bottom: '10px',
                  right: '10px',
                  backgroundColor: '#FFD700',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                  border: '2px solid #fff'
                }}
              >
                <input 
                  type="file" 
                  accept="image/*" 
                  onChange={handleProfilePicChange}
                  style={{ display: 'none' }}
                />
                <i className="fas fa-camera"></i>
              </label>
            </div>
          </Col>
        </Row>

        <Form onSubmit={handleSubmit}>
          <Row className="g-4">
            <Col lg={12}>
              <div className="form-section p-4" style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '15px',
                marginBottom: '2rem'
              }}>
                <h4 className="mb-4" style={{ color: '#000', paddingBottom: '10px' }}>
                  <i className="fas fa-user-circle me-2"></i>Personal Information
                </h4>
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-bold">First Name</Form.Label>
                      <Form.Control
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="form-control-lg"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-bold">Last Name</Form.Label>
                      <Form.Control
                        name="surname"
                        value={formData.surname}
                        onChange={handleChange}
                        required
                        className="form-control-lg"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">Gender</Form.Label>
                      <Form.Select
                        name="sex"
                        value={formData.sex}
                        onChange={handleChange}
                        required
                        className="form-control-lg"
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">Date of Birth</Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        value={formData.dob}
                        onChange={handleChange}
                        required
                        className="form-control-lg"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Col>

            <Row lg={12}>
              <div className="form-section p-4" style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '15px',
                marginBottom: '2rem'
              }}>
                <h4 className="mb-4" style={{ color: '#000', paddingBottom: '10px' }}>
                  <i className="fas fa-address-card me-2"></i>Contact Details
                </h4>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">Phone Number</Form.Label>
                      <Form.Control
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        className="form-control-lg"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="form-control-lg"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Row>

            <Col lg={12}>
              <div className="form-section p-4" style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '15px'
              }}>
                <h4 className="mb-4" style={{ color: '#000', paddingBottom: '10px' }}>
                  <i className="fas fa-lock me-2"></i>Account Security
                </h4>
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-bold">Username</Form.Label>
                      <Form.Control
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        className="form-control-lg"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">Password</Form.Label>
                      <Form.Control
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        className="form-control-lg"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">Confirm Password</Form.Label>
                      <Form.Control
                        type="password"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        required
                        className="form-control-lg"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          {(ageError || passwordError) && (
            <Alert variant="danger" className="mt-4">
              {ageError || passwordError}
            </Alert>
          )}

          <div className="text-center mt-5">
            <Button 
              type="submit" 
              disabled={loading}
              style={{
                backgroundColor: '#ffc000',
                padding: '10px 50px',
                fontSize: '1rem',
                borderRadius: '10px',
                transition: 'all 0.3s'
              }}
              className="hover-effect"
            >
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <>
                  <i className="fas fa-user-plus me-2"></i>
                  Create Account
                </>
              )}
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
};

// Add this CSS to your stylesheet
const styles = `
  .custom-input {
    border: 2px solid #e0e0e0;
    transition: all 0.3s;
    background-color: #fff !important;
  }

  .custom-input:focus {
    border-color: #FFD700;
    box-shadow: 0 0 0 0.2rem rgba(255, 215, 0, 0.25);
  }

  .form-label {
    color: #495057;
    margin-bottom: 0.5rem;
  }

  .hover-effect:hover {
    background-color: #FFD700 !important;
    border-color: #FFD700 !important;
    color: #000 !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  }

  .form-section {
    transition: all 0.3s;
  }

  .form-section:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  }
`;

export default SignUp;